import { useState } from 'react';
import '../../src/styles/loginStyle.css';
import parking from '../../src/assets/svg/book-svgrepo-com.svg';
import { useNavigate } from 'react-router-dom';
import authService from '../services/loginService';

export default function LoginScreen() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      // Validaciones básicas
      if (!email || !password) {
        setError('Por favor, complete todos los campos');
        return;
      }

      // Llamar al servicio de autenticación
      const response = await authService.loginUser(email, password);
      
      if (response.token && response.user) {
        // Redirigir según el rol del usuario
        if (response.user.role === 'Admin' || response.user.role === 'ClientService' || response.user.role === 'SuperAdmin') {
          navigate('/dashboard');
        } else if (response.user.role === 'UserApp') {
          navigate('/user-dashboard');
        } else {
          setError('Rol de usuario no reconocido');
        }
      }
    } catch (error) {
      // Manejar errores
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('Error al iniciar sesión. Por favor, intente nuevamente.');
      }
      console.error('Error de login:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* Left side with logo and title */}
      <div className="logo-container">
        <div className="logo">
          <img style={{ width: '200px', height: '200px' }} src={parking} alt="Parqueos Públicos Logo" />
        </div>
        <h1 className="app-title">Parqueos Públicos</h1>
      </div>

      {/* Car icons */}
      <div className="car-icon-top"></div>
      <div className="car-icon-bottom"></div>

      {/* Login form */}
      <div className="login-form">
        <form className="form-content" onSubmit={handleLogin}>
          {/* Mostrar errores */}
          {error && (
            <div className="error-message" style={{ 
              color: 'red', 
              marginBottom: '15px', 
              padding: '10px', 
              backgroundColor: '#ffe6e6', 
              border: '1px solid #ff9999', 
              borderRadius: '4px' 
            }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email" className="form-label">E-mail</label>
            <div className="input-container">
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="form-input"
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="password" className="form-label">Contraseña</label>
            <div className="input-container">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-input"
                disabled={loading}
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="toggle-password"
                disabled={loading}
              >
                {showPassword ?
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path>
                    <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path>
                    <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path>
                    <line x1="2" x2="22" y1="2" y2="22"></line>
                  </svg>
                  :
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                }
              </button>
            </div>
 {/*            <div className="forgot-password-container">
              <button
                type="button"
                onClick={() => console.log('Password recovery requested')}
                className="forgot-password"
                disabled={loading}
              >
                ¿Olvidó su contraseña?
              </button>
            </div> */}
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
          </button>
        </form>
      </div>
    </div>
  );
}